import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import '../styles/spinner.css'; // Import the CSS file

const Spinner = ({ message, hideSpinner }) => {
  return (
    <div className="spinner-overlay">
    <button className="close-button" onClick={hideSpinner}>Close</button>
      <CircularProgress />
      <div className="spinner-message">{message}</div>
    </div>
  );
};

export default Spinner;